// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper {\n  color: #c5c5c5;\n  min-height: 100%;\n}\n\n  .wrapper .welcome-card {\n    background: #151515;\n    width: 70%;\n    border: none;\n  }\n\n  .wrapper .demo-image {\n    width: 900px;\n    box-shadow: 5px 6px 5px #0000002b;\n    margin-bottom: 50px;\n  }\n\n  .wrapper .btn {\n    width: 250px;\n  }\n\na {\n  color: white;\n}\n\na:hover {\n  text-decoration: none;\n  color: white;\n}", ""]);
// Exports
module.exports = exports;
